import { Component, input } from '@angular/core';
import { ComponentSize } from '../types';

@Component({
  selector: 'app-skeleton',
  imports: [],
  template: `
    <div 
      [class]="skeletonClasses"
      [attr.aria-busy]="true"
      [attr.aria-label]="'Loading'">
      <div class="animate-pulse bg-gray-200 dark:bg-gray-700 rounded"></div>
    </div>
  `,
  styles: []
})
export class SkeletonComponent {
  width = input<string>('100%');
  height = input<string>('1rem');
  shape = input<'rectangle' | 'circle'>('rectangle');
  size = input<ComponentSize>('md');

  get skeletonClasses(): string {
    const classes = ['relative', 'overflow-hidden'];

    if (this.shape() === 'circle') {
      classes.push('rounded-full');
      const sizeMap = {
        xs: 'w-8 h-8',
        sm: 'w-10 h-10',
        md: 'w-12 h-12',
        lg: 'w-16 h-16',
        xl: 'w-20 h-20'
      };
      classes.push(sizeMap[this.size()]);
    } else {
      classes.push('rounded');
      classes.push(`w-[${this.width()}]`);
      classes.push(`h-[${this.height()}]`);
    }

    return classes.join(' ');
  }
}

